import {Link} from "react-router-dom";
import LegalLayout from "~/features/Legal/components/LegalLayout";
import {LEGAL} from "~/features/Legal/legalConfig";

const home = process.env.REACT_APP_HOMEPAGE || '';

/**
 * Điều khoản sử dụng — trang CÔNG KHAI (cặp với Privacy Policy, cùng phục vụ
 * Google OAuth verification: Cloud Console yêu cầu khai báo cả 2 URL).
 */
function Terms() {
	return (
		<LegalLayout title="Điều khoản sử dụng">

			<p>
				Điều khoản sử dụng này ("Điều khoản") là thoả thuận giữa bạn và <strong>{LEGAL.appName}</strong>{' '}
				(truy cập tại <strong>{LEGAL.domain}</strong>) khi bạn đăng ký và sử dụng nền tảng phân tích &amp;
				tối ưu SEO của chúng tôi. Bằng việc tạo tài khoản hoặc sử dụng dịch vụ, bạn xác nhận đã đọc,
				hiểu và đồng ý với Điều khoản này.
			</p>

			<h2>1. Mô tả dịch vụ</h2>
			<p>
				{LEGAL.appName} cung cấp các công cụ phục vụ tối ưu công cụ tìm kiếm (SEO), bao gồm: chấm điểm SEO,
				crawl và kiểm tra website, đo hiệu năng trang, tạo và kiểm tra schema, kết nối Google Search Console /
				Google Analytics, nghiên cứu từ khoá, các tính năng AI hỗ trợ nội dung và báo cáo định kỳ.
				Danh sách tính năng có thể thay đổi theo thời gian và theo gói dịch vụ.
			</p>

			<h2>2. Tài khoản</h2>
			<ul>
				<li>Bạn phải cung cấp thông tin đăng ký chính xác và giữ bí mật thông tin đăng nhập; mọi hoạt động phát sinh từ tài khoản của bạn do bạn chịu trách nhiệm.</li>
				<li>Mỗi cá nhân/tổ chức chỉ nên duy trì một tài khoản; không chia sẻ tài khoản để lách hạn mức gói.</li>
				<li>Bạn phải từ đủ 16 tuổi trở lên để sử dụng dịch vụ.</li>
			</ul>

			<h2>3. Gói dịch vụ &amp; hạn mức</h2>
			<ul>
				<li>Dịch vụ được cung cấp theo các gói (miễn phí và trả phí) với hạn mức khác nhau: số dự án, số URL kiểm tra, token AI, tần suất crawl, thời hạn lưu lịch sử…</li>
				<li>Hạn mức được đặt lại theo chu kỳ (tuần/tháng tuỳ loại). Dữ liệu lịch sử vượt quá thời hạn lưu của gói sẽ tự động bị xoá.</li>
				<li>Chúng tôi có thể điều chỉnh cấu trúc gói và hạn mức; thay đổi trọng yếu sẽ được thông báo trước.</li>
			</ul>

			<h2>4. Sử dụng hợp lệ</h2>
			<p>Bạn cam kết KHÔNG:</p>
			<ul>
				<li>Phân tích, crawl website mà bạn không sở hữu hoặc không được uỷ quyền hợp pháp;</li>
				<li>Dùng dịch vụ để tấn công, làm quá tải, thu thập dữ liệu trái phép từ website của bên thứ ba;</li>
				<li>Lách hạn mức gói (ví dụ: xoay vòng tên miền, tạo nhiều tài khoản, can thiệp API trái phép);</li>
				<li>Dùng tính năng AI để tạo nội dung vi phạm pháp luật, lừa đảo hoặc gây hại;</li>
				<li>Bán lại, cho thuê lại dịch vụ khi chưa có thoả thuận bằng văn bản với chúng tôi.</li>
			</ul>
			<p>Vi phạm có thể dẫn tới tạm ngưng hoặc chấm dứt tài khoản mà không hoàn phí (mục 9).</p>

			<h2>5. Dữ liệu &amp; quyền riêng tư</h2>
			<p>
				Việc thu thập và xử lý dữ liệu cá nhân, bao gồm dữ liệu Google Search Console / Google Analytics khi
				bạn chủ động kết nối, được mô tả trong{' '}
				<Link to={`${home}/privacy-policy`}>Chính sách bảo mật</Link> — một phần không tách rời của Điều
				khoản này. Bạn giữ toàn quyền với dữ liệu website của mình; bạn cấp cho chúng tôi quyền xử lý dữ
				liệu đó chỉ nhằm cung cấp dịch vụ cho bạn.
			</p>

			<h2>6. Dịch vụ bên thứ ba &amp; thay đổi/ngừng cung cấp tính năng</h2>
			<p>
				Một số tính năng phụ thuộc dịch vụ và nguồn dữ liệu của bên thứ ba (ví dụ: Google APIs, nhà cung cấp
				AI, nhà cung cấp dữ liệu SEO — số liệu từ khoá/thứ hạng/backlink/đối thủ, dịch vụ gửi email).
				Chúng tôi không chịu trách nhiệm về gián đoạn, thay đổi hoặc giới hạn phát sinh từ phía các dịch vụ
				này, nhưng sẽ nỗ lực hợp lý để giảm ảnh hưởng tới bạn.
			</p>
			<ul>
				<li>Chúng tôi có quyền <strong>điều chỉnh, giới hạn, tạm ngưng hoặc ngừng cung cấp</strong> bất kỳ tính năng nào — kể cả các tính năng phụ thuộc nguồn dữ liệu bên thứ ba — nếu bên thứ ba thay đổi giá, điều khoản, chính sách, khả năng cung cấp hoặc ngừng hợp tác, hoặc khi việc duy trì tính năng không còn khả thi về mặt kỹ thuật/chi phí.</li>
				<li>Khi đó, chúng tôi có thể thay đổi hạn mức và danh sách tính năng của các gói; thay đổi trọng yếu sẽ được thông báo trước qua ứng dụng hoặc email, và nếu có thể, chúng tôi sẽ cung cấp phương án thay thế.</li>
				<li>Việc ngừng một tính năng không kèm nghĩa vụ hoàn tiền, trừ phần phí trả trước cho dịch vụ chưa sử dụng (nếu có) theo quy định pháp luật hiện hành.</li>
			</ul>

			<h2>7. Nội dung do AI tạo</h2>
			<ul>
				<li>Kết quả từ tính năng AI chỉ mang tính tham khảo; bạn tự chịu trách nhiệm kiểm tra tính chính xác trước khi sử dụng, xuất bản.</li>
				<li>Bạn sở hữu nội dung do AI tạo ra theo yêu cầu của bạn, trong phạm vi pháp luật và điều khoản của nhà cung cấp mô hình cho phép.</li>
			</ul>

			<h2>8. Sở hữu trí tuệ</h2>
			<p>
				Toàn bộ mã nguồn, giao diện, nhãn hiệu và tài liệu của {LEGAL.appName} thuộc quyền sở hữu của chúng
				tôi. Bạn được cấp quyền sử dụng dịch vụ có giới hạn, không độc quyền, không chuyển nhượng, trong
				thời gian tài khoản còn hiệu lực.
			</p>

			<h2>9. Tạm ngưng, chấm dứt &amp; xoá tài khoản</h2>
			<ul>
				<li>Bạn có thể ngừng sử dụng và <strong>yêu cầu xoá tài khoản</strong> bất cứ lúc nào bằng cách liên hệ theo mục 13 (hoặc mục 10 của Chính sách bảo mật).</li>
				<li>Sau khi xác minh yêu cầu, chúng tôi sẽ xoá tài khoản cùng dữ liệu cá nhân, dự án và kết nối liên quan trong tối đa <strong>30 ngày</strong>, trừ dữ liệu buộc phải lưu theo quy định pháp luật hoặc nhật ký bảo mật đã ẩn danh.</li>
				<li>Chúng tôi có thể tạm ngưng hoặc chấm dứt tài khoản vi phạm Điều khoản, sau khi cảnh báo trừ trường hợp vi phạm nghiêm trọng.</li>
				<li>Khi tài khoản chấm dứt, dữ liệu sẽ được xoá theo chính sách lưu giữ trong <Link to={`${home}/privacy-policy`}>Chính sách bảo mật</Link>.</li>
			</ul>

			<h2>10. Miễn trừ bảo đảm &amp; giới hạn trách nhiệm</h2>
			<ul>
				<li>Dịch vụ được cung cấp "nguyên trạng" (as-is); chúng tôi không bảo đảm dịch vụ không gián đoạn, không lỗi, hay kết quả phân tích/khuyến nghị SEO sẽ mang lại thứ hạng cụ thể.</li>
				<li>Trong phạm vi pháp luật cho phép, tổng trách nhiệm của chúng tôi đối với mọi khiếu nại không vượt quá số tiền bạn đã thanh toán cho dịch vụ trong 03 tháng gần nhất.</li>
			</ul>

			<h2>11. Thay đổi điều khoản</h2>
			<p>
				Chúng tôi có thể cập nhật Điều khoản này; bản mới được đăng tại trang này kèm ngày hiệu lực mới.
				Việc tiếp tục sử dụng dịch vụ sau khi Điều khoản mới có hiệu lực đồng nghĩa bạn chấp nhận thay đổi.
			</p>

			<h2>12. Luật áp dụng</h2>
			<p>
				Điều khoản này được điều chỉnh theo pháp luật Việt Nam. Tranh chấp phát sinh sẽ ưu tiên giải quyết
				bằng thương lượng; nếu không thành, đưa ra toà án có thẩm quyền tại Việt Nam.
			</p>

			<h2>13. Liên hệ</h2>
			<p>
				Mọi câu hỏi về Điều khoản, vui lòng liên hệ:{' '}
				<a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>.
			</p>

		</LegalLayout>
	);
}

export default Terms;
